import { useState } from "react"

export const ActionStates = () => {
    const [bookings, setBookings] = useState({list: null})
    const [counts, setCounts] = useState({booked: 0, check_in: 0, check_out: 0})
    const [move, setMove] = useState({info: null, submit: {modal: false, type: '', confirmed: false}})

    return {
        bookings: {data: bookings, set: setBookings},
        counts: {data: counts, set: setCounts},
        move: {data: move, set: setMove},
    }
}